import script from "./leader.vue?vue&type=script&setup=true&lang=js"
export * from "./leader.vue?vue&type=script&setup=true&lang=js"

import "./leader.vue?vue&type=style&index=0&id=abca355a&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abca355a"]])

export default __exports__